var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.render)?_c('v-chart',{attrs:{"option":_vm.option,"autoresize":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }